import { useEffect, useRef } from "react";

/**
 * 手机全屏菜单打开期间锁住页面滚动、按 Esc 关闭。
 * 营销页 NavBar 和工具页 MobileHeader 共用，两边菜单行为保持一致。
 *
 * 替掉 Sheet 之后它带的两样要自己补：
 * - 正文和页脚设成 inert，Tab 和读屏都进不去被菜单盖住的内容（菜单本身不能放在 main/footer 里）
 * - 窗口跨到 desktopQuery 就关：菜单和按钮会被 lg:/md:hidden 藏掉，不关的话滚动一直锁着
 */
export function useFullscreenMenu(
	open: boolean,
	close: () => void,
	desktopQuery: string,
) {
	const closeRef = useRef(close);
	closeRef.current = close;

	useEffect(() => {
		if (!open) {
			return;
		}
		const root = document.documentElement;
		const previousOverflow = root.style.overflow;
		root.style.overflow = "hidden";
		const background = Array.from(
			document.querySelectorAll<HTMLElement>("main, footer"),
		).filter((el) => !el.inert);
		for (const el of background) {
			el.inert = true;
		}
		const onKeyDown = (event: KeyboardEvent) => {
			if (event.key === "Escape") {
				closeRef.current();
			}
		};
		const desktop = window.matchMedia(desktopQuery);
		const onBreakpointChange = () => {
			if (desktop.matches) {
				closeRef.current();
			}
		};
		window.addEventListener("keydown", onKeyDown);
		desktop.addEventListener("change", onBreakpointChange);
		return () => {
			root.style.overflow = previousOverflow;
			for (const el of background) {
				el.inert = false;
			}
			window.removeEventListener("keydown", onKeyDown);
			desktop.removeEventListener("change", onBreakpointChange);
		};
	}, [open, desktopQuery]);
}
